import React from 'react';

class GoogleLoginButton extends React.Component {
  componentDidMount() {
    window.google.accounts.id.renderButton(this.buttonDiv, {
      theme: 'outline',
      size: 'large',
      shape: 'pill',
      text: 'continue_with',
      width: this.buttonDiv.offsetWidth,
    });
  }

  render() {
    return (
      <div
        ref={(e) => {
          this.buttonDiv = e;
        }}
        id="buttonDiv"
        style={{
          height: '54px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      />
    );
  }
}

export default GoogleLoginButton;



// WEBPACK FOOTER //
// ./app/components/GoogleLoginButton/index.js